// TODO
const BLOCK_TERM = 3000;
const DEFAULT_DECIMALS = '1000000000000000000';

export { BLOCK_TERM, DEFAULT_DECIMALS };
